import * as history from 'history';

const createHistory = history.createBrowserHistory;

export default createHistory();
